import styled, { keyframes } from 'styled-components'

const slideUp = keyframes`
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
`

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 9999;

  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    align-items: flex-end;
  }
`

export const ModalContainer = styled.div`
  background: #fff;
  width: 496px;
  border-radius: 2px;
  overflow: hidden;
  font-family: 'Proxima-Nova';

  @media (max-width: 768px) {
    width: 100%;
    border-radius: 16px 16px 0 0;
    animation: ${slideUp} 0.3s ease;
  }
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 18px 16px;
`

export const Cancel = styled.p`
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.352px;
`

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-size: 20px;
`

export const Content = styled.div`
  padding: 0 16px 24px;
`

export const Title = styled.h2`
  margin: 0 0 20px;
  font-size: 21px;
  color: #000;
  font-style: normal;
  font-weight: 600;
  line-height: 111%; /* 23.31px */

  @media (max-width: 768px) {
    font-size: 32px;
  }
`

export const Description = styled.p`
  margin-bottom: 48px;
  color: #3b3b3b;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.352px;
`

export const ButtonGroup = styled.div`
  display: inline-flex;
  flex-direction: column;
  gap: 12px;
  justify-content: center;

  @media (max-width: 768px) {
    width: 100%;
  }
`

export const PrimaryButton = styled.button`
  border: none;
  background: #000;
  color: #fff;
  cursor: pointer;
  font-family: 'Proxima-Nova';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.9px;
  padding: 12px 32px;
  text-transform: uppercase;
`

export const SecondaryButton = styled.button`
  padding: 12px 32px;
  background: #fff;
  border: 1px solid #000;
  cursor: pointer;
  color: #000;
  text-align: center;
  font-family: 'Proxima-Nova';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.8px;
  text-transform: uppercase;
`

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
`
